const env = JSON.parse(JSON.stringify(process.env));
const {REACT_APP_BASE_URL , REACT_APP_AUTH_BASE_URL, REACT_APP_NOTISERVICE_URL, REACT_APP_DPLUS_API_URL, REACT_APP_ENABLE_REDUX_LOGGER, REACT_APP_TRACY_AUTH_BASE_URL, REACT_APP_AXUM_ACCOUNTS_BASE_URL, REACT_APP_AXUM_ACCOUNTS_ADMIN_TOKEN, REACT_APP_TRACY_BACKOFFICE_BASE_URL} = env;

if (env.NODE_ENV === "development") {
    console.log("developer mode");
    console.table(env);
}

export const BASE_URL = REACT_APP_BASE_URL || "";
export const AUTH_BASE_URL = REACT_APP_AUTH_BASE_URL || "";
export const NOTISERVICE_URL = REACT_APP_NOTISERVICE_URL || "";
export const DPLUS_API_URL = REACT_APP_DPLUS_API_URL || "";

export const ENABLE_REDUX_LOGGER = REACT_APP_ENABLE_REDUX_LOGGER || "false";

export const TRACY_AUTH_BASE_URL = REACT_APP_TRACY_AUTH_BASE_URL || "";

export const AXUM_ACCOUNTS_BASE_URL = REACT_APP_AXUM_ACCOUNTS_BASE_URL || "";
export const AXUM_ACCOUNTS_TOKEN = REACT_APP_AXUM_ACCOUNTS_ADMIN_TOKEN || "";

export const TRACY_BACKOFFICE_BASE_URL = REACT_APP_TRACY_BACKOFFICE_BASE_URL || "";
